import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import HomeViewRu from '@/views/HomeViewRu.vue'
import HomeViewBi from '@/views/HomeViewBi.vue'
import TestApi from '@/views/TestApi.vue'
import TestSwiper from '@/views/TestSwiper.vue'
import GalleryCzech from '@/views/gallery/GalleryCzech.vue'
import GalleryRussia from '@/views/gallery/GalleryRussia.vue'
import GalleryBiskek from '@/views/gallery/GalleryBiskek.vue'
import HomeViewSwith from '@/views/HomeViewSwith.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeViewSwith
  },
  {
    path: '/prague',
    name: 'home_cz',
    component: HomeView
  },
  {
    path: '/moscow',
    name: 'home_ru',
    component: HomeViewRu
  },
  {
    path: '/biskek',
    name: 'home_bi',
    component: HomeViewBi
  },
  {
    path: '/test_api',
    name: 'testApi',
    component: TestApi
  },
  {
    path: '/test_swiper',
    name: 'testSwiper',
    component: TestSwiper
  },
  {
    path: '/gallery/czech',
    name: 'GalleryCzech',
    component: GalleryCzech
  },
  {
    path: '/gallery/russia',
    name: 'GalleryRussia',
    component: GalleryRussia
  },
    {
    path: '/gallery/biskek',
    name: 'GalleryBiskek',
    component: GalleryBiskek
  },
  {
    path: '/:CatchAll(.*)',
    name: 'NotFound',
    component: HomeView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    /* console.log('router.. to=', to, 'router.. to.hash=', to.hash) */
    if (to.hash) {
      // Najdeme cílový element podle identifikátoru
      const element = document.querySelector(to.hash);
      if (element) {
        console.log('route.. elemnt=', element)
        // Posuneme stránku na cílový element
        element.scrollIntoView({ behavior: 'smooth' });
      }
      return
    } else {
      // Standardní chování routeru
      if (savedPosition) {
        return savedPosition
      } else {
        return { top: 0 }
      }
    }
  },
})

/* router.beforeEach((to, from, next) => {
  const lang = to.params.lang
  loadLanguageAsync(lang).then(() => next())
}) */

export default router